import React from 'react'

// icons
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// routes
import { withRouter } from 'react-router-dom'

// services
import useDelete from './hooks/useDelete'

const ItemFamilia = ({ familia, history, setIsLoad }) => {
    const { deleteFamilia } = useDelete(setIsLoad)

    return (
        <tr key={parseInt(familia.id)}>
            <th scope="row">{familia.id}</th>
            <td>{familia.nombre}</td>
            <td>{familia.departamento.nombre}</td>
            <td>{familia.ganancia}%</td>
            <td>
                <button
                    className="btn text-danger"
                    onClick={() => {
                        history.push(`/edit-familia/${familia.id}`, {
                            familia: familia,
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                    className="btn text-primary"
                    onClick={() => {
                        deleteFamilia(familia)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemFamilia)
